import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "../DataTable";
import { Modal } from "../Modal";
import style from "./searchModal.module.scss";
import { useHistory } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LIST_VIEW_LIMIT, PATIENT } from "../../../constants";
import { TextField } from "../../primary";
import commonStyles from "../../../styles/common.module.scss";
import searchIcon from "../../../static/images/search-icon.svg";
import { getActivePageData, getSearchValueData } from "../../../utils";
import { getCallBackListAsync, setPatients } from "../../../app/patientSlice";
import Loader from "../../../static/images/spinner.svg";
import { ModalPagination } from "../Pagination";

export const SearchModal = ({ modalOpen, setModalOpen, searchKey }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const patientsList = useSelector((state) => state.patient.patients);
  const isPatientLoading = useSelector((state) => state.patient.isPatientLoading);
  const userDetails = useSelector((state) => state.user);
  const [activePage, setActivePage] = useState(1);
  const [sortType, setSortType] = useState("");
  const [offSet, setOffSet] = useState(0);
  const [searchPatient, setSearchPatient] = useState(searchKey);
  const [showClearX, setShowClearX] = useState(searchPatient ? true : false);

  const showCount =
    activePage * patientsList?.data?.metadata?.limit <= patientsList?.data?.metadata?.total
      ? activePage * patientsList?.data?.metadata?.limit
      : patientsList?.data?.metadata?.total;

  const patientData = Array.isArray(patientsList?.data?.patients) ? patientsList.data.patients : [];

  const sortingPayLoad = useMemo(
    () => ({
      url: PATIENT,
      method: "Get",
      queryParam: {
        facilityNumber: "",
        customerNumber: userDetails?.customerNumber,
        offSet: isNaN(offSet) === true ? 0 : offSet,
        limit: LIST_VIEW_LIMIT,
        search: searchKey ? searchKey : "",
        pagetype: "patient",
        sort: sortType ? sortType : "",
      },
      setMethod: setPatients,
      setSortType: setSortType,
      sortType: sortType,
      asyncMethod: getCallBackListAsync,
    }),
    [offSet, searchKey, setSortType, sortType, userDetails?.customerNumber]
  );

  const getActivePage = (data) => {
    setOffSet(data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT);
    getActivePageData(
      data,
      setActivePage,
      PATIENT,
      userDetails?.customerNumber,
      LIST_VIEW_LIMIT,
      setPatients,
      dispatch,
      getCallBackListAsync,
      searchPatient,
      false,
      "",
      sortType
    );
  };

  useEffect(() => {
    setShowClearX(!!searchPatient);
  }, [searchPatient, setShowClearX]);

  const columns = [
    {
      Header: "MRN # ",
      accessor: "mrn",
      disableSortBy: false,
      fixedColumn: false,
      restWidth: "170px",
    },
    {
      Header: "Facility Number",
      accessor: "facilityNumber",
      restWidth: "170px",
    },
    {
      Header: "First name",
      accessor: "firstName",
      restWidth: "170px",
    },
    {
      Header: "Last name",
      accessor: "lastName",
      restWidth: "170px",
    },
    {
      Header: "Gender",
      accessor: "gender",
      restWidth: "120px",
    },
    {
      Header: "DOB",
      accessor: "dob",
      restWidth: "150px",
    },
  ];

  const handleSelectedRowData = (data) => {
    setModalOpen(false);
    if (data) {
      history.push("/patients/" + data.ne1Id);
    }
  };

  const handleSort = useCallback(
    (data) => {
      if (!sortingPayLoad) return;
      const sortingColumn = data.sortBy?.[0];
      const sortValue = sortingColumn ? `${sortingColumn.id}${sortingColumn.desc ? ":DESC" : ":ASC"}` : sortType;
      sortingPayLoad.queryParam.sort = sortValue;

      if (sortingPayLoad.setSortType && sortValue) {
        sortingPayLoad.setSortType(sortValue);
      }
      dispatch(sortingPayLoad.asyncMethod(sortingPayLoad));
    },
    [sortingPayLoad, dispatch, sortType]
  );

  const getSearchPatient = (e) => {
    getSearchValueData(
      e,
      PATIENT,
      userDetails?.customerNumber,
      offSet,
      LIST_VIEW_LIMIT,
      setPatients,
      setSearchPatient,
      dispatch,
      getCallBackListAsync,
      false,
      "",
      sortType
    );
  };

  const handlePatientSearch = (e) => {
    e.preventDefault();
    if (e?.keyCode === 13) {
      getSearchPatient(e);
    }
  };

  return (
    <Modal
      className={style.searchModalP}
      modalOpen={modalOpen}
      modalClose={() => setModalOpen(false)}
      modalSize={style.custom_modal_size}
      heading="Patient Search"
    >
      <div className="mx-2">
        <div className={`col-12`}>
          <TextField
            classes={{
              column: `form-group no-gutters ${commonStyles.form_group} position-relative col-sm-8 p-0 m-2`,
              inputClassName: `form-control mb-1 ${style.pl40} `,
              labelClass: `position-absolute ${style.search_icon_image}`,
            }}
            label={<img src={searchIcon} alt="search icon" />}
            type={"text"}
            name={"searchPatient"}
            id={"searchPatient"}
            placeholder={"MRN#, First Name, Last Name"}
            onKeyUp={handlePatientSearch}
            getSearchValue={getSearchPatient}
            value={searchPatient}
            onChange={(e) => setSearchPatient(e?.target?.value)}
            showClearX={showClearX}
            setShowClearX={setShowClearX}
          />
        </div>
        {isPatientLoading && (
          <div className={`loader col-12`}>
            <img src={Loader} alt="loading" />
          </div>
        )}
        <div className={`${isPatientLoading ? "d-none" : ""}`}>
          <div className="m-4">
            <DataTable
              columns={columns}
              data={patientData}
              sorting={true}
              getSelectedRowData={handleSelectedRowData}
              setSelectedRows={() => {}}
              onSort={handleSort}
              detailView={true}
              deleteDataList={() => {}}
              showFixedColumn={false}
              workListView={true}
              searchKey={searchPatient}
              activePage={activePage}
              sortType={sortType}
            />
          </div>
          {patientData?.length > 0 && (
            <ModalPagination
              activePage={activePage}
              showCount={showCount}
              totalItemsCount={patientsList?.data?.metadata?.total || 0}
              itemsCountPerPage={patientsList?.data?.metadata?.limit || 50}
              handleClick={getActivePage}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};
